"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  margin: 0 5px;\n  text-align: center;\n\n  &:first-of-type {\n    line-height: ", ";\n    padding: 12px 16px;\n    text-align: left;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  display: grid;\n  grid-template-columns: 160px auto 160px;\n  height: 48px;\n  user-select: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  display: inline-block;\n  height: 48px;\n  line-height: ", ";\n  min-width: 48px;\n  padding: 12px;\n\n  &:hover,\n  &:focus,\n  &[data-active='true'] {\n    background-color: ", ";\n    cursor: pointer;\n  }\n\n  &[data-active='true'] {\n    border-bottom: 4px solid ", ";\n    font-weight: 600;\n  }\n\n  &.action {\n    padding: 8px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  height: 48px;\n  user-select: none;\n  display: flex;\n  text-align: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginationTableGroup = exports.paginationTable = exports.paginationItem = exports.pagination = void 0;

var _core = require("@emotion/core");

var _reset = require("../../utilities/reset");

var pagination = function pagination(_ref) {
  var theme = _ref.theme;
  return (0, _core.css)(_templateObject(), theme.bColorneutral02);
};

exports.pagination = pagination;

var paginationItem = function paginationItem(_ref2) {
  var theme = _ref2.theme;
  return (0, _core.css)(_templateObject2(), (0, _reset.button)(), theme.bTextsupportLineHeight, theme.bColorsecondary01, theme.bColorsecondary05);
};

exports.paginationItem = paginationItem;

var paginationTable = function paginationTable(_ref3) {
  var theme = _ref3.theme;
  return (0, _core.css)(_templateObject3(), theme.bColorneutral02);
};

exports.paginationTable = paginationTable;

var paginationTableGroup = function paginationTableGroup(_ref4) {
  var theme = _ref4.theme;
  return (0, _core.css)(_templateObject4(), theme.bTextsupportFontSize, theme.bTextsupportLineHeight);
};

exports.paginationTableGroup = paginationTableGroup;